import React, { useState, useEffect } from "react";
import IconTick from "../../iconComponents/IconTick";
import IconX from "../../iconComponents/IconX";
import { connect, useSelector } from "react-redux";
import Addfiles from "../../common/Addfiles";


export function InvoiceStep4ConfirmReceived(props) {

const [response, setResponse] = useState(null);
const [notes, setNotes] = useState(null);
const invoice = useSelector( (state) => state.invoices.invoice );

const handleChangeValue = (e) => {
    setResponse(e.target.value);
}
const handleAddNotes = (e) => {
    setNotes(e.target.value);
}
// const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log({response: response, notes: notes});
// }
const handleSubmit = (e) => {
    e.preventDefault();
    const purchaserName = invoice.company_purchaser?.name ? invoice.company_purchaser.name : "Purchaser"
    const message1 = "Invoice successfully closed";
    const message2 = `${purchaserName} notified of missing payment`;
    if (response === "received") {
        props.handleResponseSubmit({stage: "PC", notes: notes}, message1);
    } else {
        props.handleResponseSubmit({stage: "PR", notes: notes}, message2);
    }
}

    return (
        <form onSubmit={(e) => handleSubmit(e)} className="gap-above-m gap-below-s">
            <div className={response === "received" ? "typical-radio checked" : "typical-radio"} >
                <input type="radio" id="received" name="receipt" value="received" onChange={(e) => handleChangeValue(e)} checked={response === "received"}/>
                <label className="content2" htmlFor="received"><IconTick height="12px" className="iblock gap-right-xxs" /> Payment was received in full</label>
            </div>
            <div className={response === "notreceived" ? "typical-radio checked gap-below-xs" : "typical-radio gap-below-xs"} >
                <input type="radio" id="notreceived" name="receipt" value="notreceived" onChange={(e) => handleChangeValue(e)} checked={response === "notreceived"}/>
                <label className="content2" htmlFor="notreceived"><IconX height="12px" className="iblock gap-right-xxs" />  Payment was not received in full</label>
            </div>
            <div className="gap-above-s gap-below-s">
                <p className="content2 heavy-grey gap-below-xs">Supporting Documents</p>
                <Addfiles 
                    uploadTitle="+ Add Supporting Docs"
                    selectedFiles={props.selectedFilesAdditional}
                    handleDrop={props.handleDrop}
                    removeSelectedFile={props.removeSelectedFile}
                    // removeUploadedFile={removeUploadedFileInvoiceAdditional}
                    // removedFiles={removedFilesInvoiceAdditional}
                    maxSize={10485760}
                    maxFiles={0}
                    multiple={true}
                    accept=""
                />
            </div>
            <div className="inputs-wrapper" >
                <div className="input-basic addspace textarea">	
                    <label className="textarea" htmlFor="notes">Notes{response === "received" ? " (optional)" : <span>*</span>}</label>	
                    <textarea type="text" name="notes" id="notes" rows="3" required={response === "notreceived"} onChange={(e) => handleAddNotes(e)}/>
                </div>
            </div>
            <div className="gap-above-s">
                <button id="invoice_pay_receive_confirm" className="btn pri min-width" type="submit" disabled={!response || (response === "notreceived" && !notes) || props.isSubmitting} >{props.isSubmitting ? "Please wait..." : "Confirm"}</button>
            </div>
        </form> 
    )
}


const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps)(InvoiceStep4ConfirmReceived);